import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  listaPendentes: () => {
    return Vue.http.get('/api/solicitacaoreembolsos/atividades');
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaoreembolsos/${id}/arquivos`)
      .then(response => response.data);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaoreembolsos/cript/${id}`)
      .then(response => response.data);
  },
  salvarAtividade: (id, formData) => {
    return Vue.http.post(`/api/solicitacaoreembolsos/cript/${id}/Atividade`, formData);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-reembolso-atividade/servico.js